import { result } from 'underscore';
import { isNewOnboardingVisibleStore, ONBOARDING_PREFERENCE } from '@bingads-webui-campaign-react/onboarding-toggle';
import { BaseSurvey } from '../base-survey';
import { CampaignOnboardingSurveyView } from './view';

export class CampaignOnboardingSurvey extends BaseSurvey {
  getSurveyName = () => 'CampaignOnboardingSurvey';

  getSurveyId = isTestEnv => (isTestEnv ? '5a4a0bae-22f4-446e-bf18-4045ecabf835' : '23e8efd4-39cf-4a81-a261-cd90db48e714');

  validateTriggerCondition = () => result(window, ['survey', 'switchBackToOldCampaignOnboarding']);

  onSurveySubmit = () => {
    window.survey.onSwitchBackToOldSurveySubmit = true;

    this.SurveyPreferenceService.PreferenceService.setAtUserLevel({
      Name: ONBOARDING_PREFERENCE,
      Data: false,
    });

    isNewOnboardingVisibleStore.setState({
      isNewOnboardingVisible: false,
    });

    window.survey.switchBackToOldCampaignOnboarding = false;
  };

  onSurveyDismiss = () => {
    window.survey.onSwitchBackToOldSurveyDismiss = true;
    window.survey.switchBackToOldCampaignOnboarding = false;
  };

  getSurveyComponent = () => CampaignOnboardingSurveyView;
}
